import { useState, useMemo, useEffect } from 'react';
import { Section } from '@prosolve/common-components-ui'
import Tabs from '../../sharedComponents/Tabs';
import EventsList from '../../EventsList/EventsList';
import Cookies from 'js-cookie';
import { getClientSubdomain } from '../../../utils';
import Filters from './Filters/Filters';
import useForm from '../../../hooks/useForm';
import DownloadConsultNotesButton from './DownloadConsultNotesButton';

export default () => {
  const userId = Cookies.get('loggedInUserId');

  const clientSubdomain = getClientSubdomain()
  
  const isStarSubdomain = (clientSubdomain === 'star')

  let eventDisplayFiltersFromStorage = {};
  try {
    eventDisplayFiltersFromStorage = JSON.parse(sessionStorage.getItem("eventDisplayFilters") || '{}')
  } catch (e) {
    console.log(e)
  }

  const tabsByMode = {
    date: ['Upcoming', 'Past', 'Calendar'], //, 'Response Needed', 'Declined'];
    status: ['Open', 'Closed', 'Calendar']
  }

  const [isLoading, setIsLoading] = useState(true)
  const [filteredEvents, setFilteredEvents] = useState([])

  const [tabMode, setTabMode] = useState(
    ['date', 'status'].includes(eventDisplayFiltersFromStorage.tabMode)
      ? eventDisplayFiltersFromStorage.tabMode
      : (isStarSubdomain ? 'status' : 'date')
  )

  const tabs = tabsByMode[tabMode];

  const [selectedTab, setSelectedTab] = useState(() => {
    const initialTabs = tabsByMode[
      ['date', 'status'].includes(eventDisplayFiltersFromStorage.tabMode)
        ? eventDisplayFiltersFromStorage.tabMode
        : (isStarSubdomain ? 'status' : 'date')
    ]
    return initialTabs.includes(eventDisplayFiltersFromStorage.type) ? eventDisplayFiltersFromStorage.type : initialTabs[0]
  })

  const onToggleTabMode = () => {
    const newTabMode = (tabMode === 'date') ? 'status' : 'date'
    const tabIndex = tabsByMode[tabMode].indexOf(selectedTab)
    setTabMode(newTabMode)
    setSelectedTab(tabsByMode[newTabMode][tabIndex > -1 ? tabIndex : 0])
  }

  const [eventFilters] = useState({ userId })

  const filtersFormSchema = {
    requiredFields: [],
    optionalFields: [/*'accountId'*/ 'account', 'trainer', 'csSpecialist', 'startDate', 'endDate'],
    initData: eventDisplayFiltersFromStorage
  };
  
  const formData = useForm(filtersFormSchema)

  const eventDisplayFilters = useMemo(() => {
    return {
      type: selectedTab,
      tabMode,
      ...formData.values
    }
  }, [selectedTab, tabMode, formData.values])

  useEffect(() => {
    sessionStorage.setItem("eventDisplayFilters", JSON.stringify(eventDisplayFilters));
  }, [eventDisplayFilters])

  const onFilteredEventsChange = (events) => {
    setFilteredEvents(events)
  }

  const onEventsLoadingChange = (isLoading) => {
    setIsLoading(isLoading)
  }

  return (
    <Section style={{ padding: '0px' }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        position: 'relative'
      }}>
        <div
          style={{
            color: '#565656',
            fontSize: '24px',
            fontWeight: 'bold',
          }}
        >
          {'Program Events'}
        </div>
        <Filters formData={formData} />
      </div>
      <div style={{ position: 'relative' }}>
        <Tabs tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        <div style={{
          position: 'absolute',
          right: '25px',
          bottom: '2px',
          padding: '2px',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '15px',
        }}>
          {isStarSubdomain && !isLoading &&
            <DownloadConsultNotesButton events={filteredEvents} />
          }
          <span
            onClick={onToggleTabMode}
            style={{
              fontSize: '12px',
              fontStyle: 'italic',
              textDecoration: 'underline',
              color: '#44ACE1',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {tabMode === 'date' ? 'Switch to Open / Closed' : 'Switch to Upcoming / Past'}
          </span>
        </div>
      </div>
      <div style={{ padding: '20px' }}>
        <EventsList filters={eventFilters} displayFilters={eventDisplayFilters} onFilteredEventsChange={onFilteredEventsChange} onEventsLoadingChange={onEventsLoadingChange} />
      </div>
    </Section>
  )
}
